// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-footer-container {
    margin-top: 5px;
    height: 50px;
}
.pagination-footer-info {
    height: 100%;
    width: 210px;
    font-size: 14px;
    color: #707070;
}
.pagination-footer-count {
    margin-left: 4px;
    margin-right: 4px;
}
.pagination-page {
    width: 43px;
    height: 30px;
    background-color: #FAFBFD;
    cursor: pointer;
}
.pagination-page:first-child {
    border-radius: 8px 0 0 8px;
    border: 1px solid #D5D5D5;
}
.pagination-page:last-child {
    border-radius: 0 10px 10px 0;
    border: 1px solid #D5D5D5;
    border-left: none;
}
.pagination-page:last-child > img {
    transform: rotateZ(-180deg);
}

.pagination-page:last-child > div > img {
    transform: rotateZ(-180deg);
}

.change_limit_box {
    position: relative;
}

.change_limit_box > p {
    font-size: 14px;
    color: #707070;
    margin-right: 30px;
}

.change_limit_box > p > span {
    color: #00acee;
    font-weight: 600;
    text-decoration: underline;
}

.change_limit_box > p > img {
    width: 24px;
    margin-bottom: -7px;
}

.change_limit_menu {
    position: absolute;
    background-color: white;
    font-size: 12px;
    right: 25px;
    top: 20px;
    border-radius: 3px;
    padding-top: 5px;
    padding-bottom: 5px;
    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
}

.change_limit_item {
    padding-top: 3px;
    padding-bottom: 3px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
}

.change_limit_item:hover {
    background-color: rgba(112, 112, 112, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/Pagination.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IAEnB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".pagination-footer-container {\n    margin-top: 5px;\n    height: 50px;\n}\n.pagination-footer-info {\n    height: 100%;\n    width: 210px;\n    font-size: 14px;\n    color: #707070;\n}\n.pagination-footer-count {\n    margin-left: 4px;\n    margin-right: 4px;\n}\n.pagination-page {\n    width: 43px;\n    height: 30px;\n    background-color: #FAFBFD;\n    cursor: pointer;\n}\n.pagination-page:first-child {\n    border-radius: 8px 0 0 8px;\n    border: 1px solid #D5D5D5;\n}\n.pagination-page:last-child {\n    border-radius: 0 10px 10px 0;\n    border: 1px solid #D5D5D5;\n    border-left: none;\n}\n.pagination-page:last-child > img {\n    transform: rotateZ(-180deg);\n}\n\n.pagination-page:last-child > div > img {\n    transform: rotateZ(-180deg);\n}\n\n.change_limit_box {\n    position: relative;\n}\n\n.change_limit_box > p {\n    font-size: 14px;\n    color: #707070;\n    margin-right: 30px;\n}\n\n.change_limit_box > p > span {\n    color: #00acee;\n    font-weight: 600;\n    text-decoration: underline;\n}\n\n.change_limit_box > p > img {\n    width: 24px;\n    margin-bottom: -7px;\n}\n\n.change_limit_menu {\n    position: absolute;\n    background-color: white;\n    font-size: 12px;\n    right: 25px;\n    top: 20px;\n    border-radius: 3px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;\n}\n\n.change_limit_item {\n    padding-top: 3px;\n    padding-bottom: 3px;\n    padding-left: 10px;\n    padding-right: 10px;\n    cursor: pointer;\n}\n\n.change_limit_item:hover {\n    background-color: rgba(112, 112, 112, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
